import type { InjectionKey } from 'vue'

import type { ClientPortalExperienceRuntime } from './clientportal-experience.types'

export type ClientPortalV2Handler = (params: Record<string, unknown>) => unknown | Promise<unknown>

export interface ClientPortalV2ScreenRuntime {
  readonly handlers: Readonly<Record<string, ClientPortalV2Handler>>
}

export const CLIENTPORTAL_EXPERIENCE_RUNTIME_KEY: InjectionKey<Readonly<ClientPortalExperienceRuntime>> =
  Symbol('clientportal-experience-runtime')

export const CLIENTPORTAL_V2_SCREEN_RUNTIME_KEY: InjectionKey<Readonly<ClientPortalV2ScreenRuntime>> =
  Symbol('clientportal-v2-screen-runtime')
